var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-alert',{attrs:{"type":"error"}},[(!_vm.user)?_c('span',[_vm._v("認証に失敗しました。")]):_c('span',[_vm._v("エラーが発生しました。")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }